import { useEffect, useState } from 'react';

/**
 *  Listen for the message window event sent by the kbb ads sdk:
 *  https://ghe.coxautoinc.com/KelleyBlueBook-Cumulus/kbbsdk-ads
 *
 *  Parameter: elementId - the id of the AdSlot
 *
 *  If the message event sends back a message of type 'hideById' and the elementId matches the slot id of the ad you
 *  want to check, then that means the ad is not flighted in that instance, and you should use the result of this
 *  hook to hide the container of the ad
 *
 */
export default function useMessageEvent(elementId) {
  const [isAdHidden, setAdHidden] = useState(false);
  useEffect(() => {
    const handler = e => {
      try {
        const msg = JSON.parse(e.data);
        if (e.origin && e.origin.includes('kbb.com') && msg.type === 'hideById' && msg.elementId === elementId) {
          setAdHidden(true);
        }
      } catch (error) {
        // do nothing
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [elementId, isAdHidden]);
  return isAdHidden;
}